export default "__VITE_ASSET__C43elOtA__"